export interface PageEvent {
    first: number;
    rows: number;
    page: number;
    pageCount: number;
}

export enum ViewMode {
    TableView,
    ListView,
    TileView
}

export enum EditCustomerMode {
    Full = 0,
    Visitor,
    Delivery,
    Invoice
}
